import React, {FC} from "react";
import {IdlocaGeneric} from "../locales/IdlocaGeneric";
import {NoData} from "../components/table/NoData";
import {RoutesPath} from "../enums/RoutesPath";

export const PageNotFound: FC = () => {
    return (
        <NoData
            messageLocaId={IdlocaGeneric.page_not_found}
            redirectButtonLocaId={IdlocaGeneric.go_to_catalogue}
            redirectUrl={RoutesPath.CATALOGUE}
        />
    );
};


